import EstablishmentHeader from "./EstablishmentHeader";

export default EstablishmentHeader;
